import React from 'react';
import stylesPlain from '../../components/plain/plain.module.css';

import PlainPage from '../../components/plain/PlainPage';
import DivOrganization, {validateOrganization} from './components/DivOrganization';

import {getLanguage} from '../../util/localStorage';
import {FORM_ORGANIZATION_PLAIN} from '../../util/consts/forms';
import {CLASS_ORGANIZATION} from '../../util/consts/classes';

class OrganizationPlainPage extends PlainPage {

	constructor(props) {
		super(props);
		this.formPath = FORM_ORGANIZATION_PLAIN;
		this.formTitle = 'Організація';
		this.buildInstanceCard = this.buildOrganizationCard;
	}
	componentDidMount = async () => {
		this.init(CLASS_ORGANIZATION)
		document.title = 'BOM. ' + this.formTitle;
	}
	
	buildOrganizationCard = (organizationInstance) => {
		let card = '';
		let currentLanguage = getLanguage();
		let name = null;
		for(let n of organizationInstance.rootField.value.names.value) {
			if( n.value.language.value == currentLanguage && n.value.name.value ) {
				name = n;
				break;
			}
		}
		if( name == null && organizationInstance.rootField.value.names.value.length > 0)
			name = organizationInstance.rootField.value.names.value[0];
		if( name != null ) {
			if( name.value.name.value )
				card += name.value.name.value;
			else if( name.value.shortName.value )
				card += name.value.shortName.value;
		} 
		return card;
	}
	
	validateInstance() {
		return validateOrganization(this.instance, this.instance.rootField);
	}

	
	
	renderBody() {
		let instance = this.state.instance;
		let fieldGroup = instance.rootField;
		let readOnly = this.instanceReadOnly;
		return (
			<div className={stylesPlain.divPlainMain}>
				{this.renderHeader()}
				
				{/* Body */}
				<div className={stylesPlain.divPlainBody} >
					<DivOrganization instance={instance} fieldGroup={fieldGroup} readOnly={readOnly} plain={this}/>
				</div>
			</div>
		)
	}
}

export default OrganizationPlainPage;
